/**
 * 认证相关 API
 * - login / register：返回用户信息（Token 通过 Set-Cookie 自动存储）
 * - refresh：刷新 Access Token（由 request.ts 拦截器自动调用）
 * - logout：清除服务端 Cookie
 * - getMe：获取当前登录用户信息
 * - githubLogin：跳转 GitHub OAuth 授权页
 */
import request from "./request";
import type {
  AuthResponse,
  LoginDto,
  RegisterCaptchaChallenge,
  RegisterCaptchaVerifyResult,
  RegisterDto,
  SendEmailCodeResult,
  User
} from "@/types";
import { appConfig } from "@/config";

export const authApi = {
  /** 用户名密码登录 */
  login(data: LoginDto) {
    return request.post<unknown, AuthResponse>("/auth/login", data);
  },

  /** 用户注册（注册成功自动登录） */
  register(data: RegisterDto) {
    return request.post<unknown, AuthResponse>("/auth/register", data);
  },

  getRegisterCaptcha() {
    return request.get<unknown, RegisterCaptchaChallenge>("/auth/register-captcha");
  },

  verifyRegisterCaptcha(data: {challengeId: string; x: number; y: number}) {
    return request.post<unknown, RegisterCaptchaVerifyResult>("/auth/register-captcha/verify", data);
  },

  sendEmailCode(data: {email: string; challengeId: string}) {
    return request.post<unknown, SendEmailCodeResult>("/auth/email-code", data);
  },

  /** 刷新 Token（Cookie 自动携带 refreshToken） */
  refresh() {
    return request.post("/auth/refresh");
  },

  /** 登出（清除 HttpOnly Cookie） */
  logout() {
    return request.post("/auth/logout");
  },

  /** 获取当前用户信息 */
  getMe() {
    return request.get<unknown, User>("/users/me");
  },

  /** GitHub OAuth 登录（整页跳转到后端 OAuth 入口） */
  githubLogin() {
    window.location.href = appConfig.api.githubLoginURL;
  },
};
